import { Button, useMediaQuery } from '@mui/material'
import Stack from '@mui/material/Stack'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { format as dateFnsFormat } from 'date-fns/format'
import { ru } from 'date-fns/locale'
import { useState } from 'react'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import { useWrapperStore } from '../../store/storeWrapper'
import { theme } from '../../theme'
import { AssistantDisconnectDialog } from '../AssistantDisconnectDialog'
import CancelIcon from './../../assets/icons/Cancel.svg?react'
import RepeatIcon from './../../assets/icons/Repeat.svg?react'

export const AssistantSubscriptionsDialog = ({ open, handleClose, handleSubmit, assistant }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { assistantSubscriptions, changeAssistantSubscription, fetchAssistantSubscriptions, isLoadingFetchAssistantSubscriptions  } = useWrapperStore(
        (state) => state,
    )

    const [openAssistantDisconnectDialog, setOpenAssistantDisconnectDialog] =
        useState<boolean>(false)
    const [assistantSelected, setAssistantSelected] = useState({})

    const handleCloseAssistantDisconnectDialog = () => {
        setOpenAssistantDisconnectDialog(false)
    }

    const handleSubmitAssistantDisconnectDialog = () => {}

    const handleOpenAssistantDisconnectDialog = async (item) => {
        if (item.auto_renew) {
            setAssistantSelected(item)
            setOpenAssistantDisconnectDialog(true)
        } else {
            await changeAssistantSubscription(item.id)
            fetchAssistantSubscriptions()
        }
    }

    return (
        <ModalDialogWrapper
            sx={{
                '.MuiPaper-root': {
                    width: '844px',
                    maxWidth: '844px',
                    height: 'auto',
                },
            }}
            colorSubmitButton="secondary"
            variantCloseButton="contained"
            open={open}
            handleClose={handleClose}
            title="Управление подписками">
            {!isMobile && (
                <TableContainer sx={{ width: '100%', overflowY: 'auto', p: 0, mb: 3 }}>
                    <Table
                        sx={{
                            borderCollapse: 'separate',
                            borderSpacing: ' 0 8px',
                            boxSizing: 'border-box',
                        }}>
                        <TableHead sx={{ borderTop: 'none', borderSpacing: '0' }}>
                            <TableRow sx={{ background: '#F5F5F5' }}>
                                <TableCell
                                    sx={{ backgroundColor: '#F4F4F6' }}
                                    style={{
                                        borderTopLeftRadius: '16px',
                                    }}>
                                    Название
                                </TableCell>
                                <TableCell
                                    sx={{ backgroundColor: '#F4F4F6' }}
                                    style={{
                                        borderTopLeftRadius: 0,
                                    }}>
                                    Статус
                                </TableCell>
                                <TableCell
                                    sx={{ backgroundColor: '#F4F4F6' }}
                                    style={{
                                        borderTopLeftRadius: 0,
                                    }}>
                                    Активен до
                                </TableCell>
                                <TableCell
                                    sx={{
                                        backgroundColor: '#F4F4F6',
                                        color: '#5A5F72',
                                        borderTopRightRadius: '16px',
                                    }}
                                />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {assistantSubscriptions?.length === 0 && (
                                <TableRow>
                                    <TableCell
                                        colSpan={4}

                                            style={{
                                            borderBottomLeftRadius: '16px',
                                            borderLeft: '1px solid #F6F6F6',
                                            borderBottomRightRadius: '16px',
                                            borderRight: '1px solid #F6F6F6',
                                        }}>
                                        Нет активных подписок
                                    </TableCell>
                                </TableRow>
                            )}
                            {assistantSubscriptions?.length > 0 &&
                                assistantSubscriptions.map((item, index) => {
                                    return (
                                        <>
                                            <TableRow key={item.id}>
                                                <TableCell
                                                    style={{
                                                        borderBottomLeftRadius:
                                                            index === assistantSubscriptions.length - 1
                                                                ? '16px'
                                                                : '0',
                                                        borderLeft: '1px solid #F6F6F6',
                                                    }}>
                                                    {item.assistant_name}
                                                </TableCell>
                                                <TableCell>
                                                    {item.auto_renew ? 'Активна' : 'Приостановлена'}
                                                </TableCell>
                                                <TableCell>
                                                    {dateFnsFormat(item?.end_at, 'd MMMM yyyy', {
                                                        locale: ru,
                                                    })}
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        borderBottomRightRadius:
                                                            index === assistantSubscriptions.length - 1
                                                                ? '16px'
                                                                : '0',
                                                        borderRight: '1px solid #F6F6F6',
                                                    }}>
                                                    <Button
                                                        disabled={isLoadingFetchAssistantSubscriptions}
                                                        onClick={() =>
                                                            handleOpenAssistantDisconnectDialog(
                                                                item,
                                                            )
                                                        }
                                                        variant="text"
                                                        startIcon={
                                                            item.auto_renew ? (
                                                                <CancelIcon />
                                                            ) : (
                                                                <RepeatIcon />
                                                            )
                                                        }
                                                        sx={{
                                                            gap: '4px',
                                                            px: '8px',
                                                            '&>.MuiButton-icon': {
                                                                mr: 0,
                                                            },
                                                        }}>
                                                        {item.auto_renew
                                                            ? 'Отменить подписку'
                                                            : 'Возобновить подписку'}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    )
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
            {isMobile && (
                <>
                    {assistantSubscriptions?.length > 0 &&
                        assistantSubscriptions.map((item, index) => {
                            return (
                                <Stack
                                    mb={2}
                                    p={2}
                                    sx={{
                                        borderRadius: '12px',
                                        background: ' #F5F5F5',
                                    }}>
                                    <Typography variant="h5" my={1}>{item.assistant_name}</Typography>
                                    <Typography variant="body2" sx={{ color: '#5A5C5E' }}>
                                        Статус:{' '}
                                        <span style={{ color: '#1B1C1D' }}>
                                            {' '}
                                            {item.is_active ? 'Активна' : 'Приостановлена'}
                                        </span>
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: '#5A5C5E' }} >
                                        Активен до:{' '}
                                        <span style={{ color: '#1B1C1D' }}>
                                            {' '}
                                            {dateFnsFormat(item?.end_at, 'd MMMM yyyy', {
                                                locale: ru,
                                            })}
                                        </span>
                                    </Typography>
                                    <Button
                                        onClick={() => handleOpenAssistantDisconnectDialog(item)}
                                        variant="text"
                                        startIcon={item.auto_renew ? <CancelIcon /> : <RepeatIcon />}
                                        sx={{
                                            justifyContent: 'left',
                                            gap: '4px',
                                            px: '0px',
                                            '&>.MuiButton-icon': {
                                                mr: 0,
                                            },
                                        }}>
                                        {item.auto_renew
                                            ? 'Отменить подписку'
                                            : 'Возобновить подписку'}
                                    </Button>
                                </Stack>
                            )
                        })}
                    {
                        assistantSubscriptions?.length === 0 && <Typography variant="body2" sx={{ color: '#5A5C5E' }} > Нет активных подписок</Typography>
                    }
                </>
            )}
            <AssistantDisconnectDialog
                assistant={assistantSelected}
                open={openAssistantDisconnectDialog}
                handleSubmit={handleSubmitAssistantDisconnectDialog}
                handleClose={handleCloseAssistantDisconnectDialog}
            />
        </ModalDialogWrapper>
    )
}
